module.exports = __webpack_public_path__ + "img/Menu.3ca5868a.svg";